<div class="row">
  <div class="col">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active"><a class="" [routerLink]="'/clients-to-call'" routerLinkActive="active">
            Clients to Call</a></li>
        <li class="breadcrumb-item active">
          <ng-container *ngIf="isSurveyLoading">
            <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
          </ng-container>
          <ng-container *ngIf="!isSurveyLoading">
            <a class="" [routerLink]="['/matters/details', survey.caseId, survey.surveyTypeId, month, year]"
              routerLinkActive="active">
              Matter {{matterNumber}}</a>
          </ng-container>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Survey Details</li>
      </ol>
    </nav>
  </div>
</div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <h1 class="h2">Survey Details - Survey ID #{{surveyId}}</h1>
</div>
<div class="row mb-3">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0">Basic Info</h6>
    </div>
    <div class="card-body">
      <ng-container *ngIf="isSurveyLoading">
        <div class="loading-cover">
          <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
        </div>
      </ng-container>
      <ng-container *ngIf="!isSurveyLoading">
        <dl class="row">
          <dt class="col-sm-3">Matter Number</dt>
          <dd class="col-sm-9"><a class="btn btn-link p-0 m-0"
              [routerLink]="['/matters/details', survey.caseId, survey.surveyTypeId, month, year]">
              {{matterNumber}}
            </a></dd>
          <dt class="col-sm-3">Survey Type</dt>
          <dd class="col-sm-9">{{survey.surveyType?.value}}</dd>

          <dt class="col-sm-3">Date Taken</dt>
          <dd class="col-sm-9">{{ survey.surveyDate! | formatUtcDate}}
          </dd>

          <dt class="col-sm-3">Survey Method</dt>
          <dd class="col-sm-9">{{survey.surveyMethod?.value}}</dd>
        </dl>
      </ng-container>
    </div>


  </div>
</div>
<div class="row">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0">Versions</h6>
    </div>
    <div class="card-body">
      <app-survey-version-grid (reloadParent2)="reloadSurveyDetails()" [survey]="survey"
        [surveyVersions]="survey == undefined ? null : survey.versions"></app-survey-version-grid>
    </div>

  </div>
</div>